import PersonDetails from "./PersonDetails";

import PersonalAndFatca from "./PersonalAndFatca";

function PiFormQuestions(props) {
  const {
    isPersonalDetails,
    isPepAndKyc,
    fullCountries,
    texClassifications,
    person,
    pepCategory,
    isPep,
    accountPurposes,
    employMentStatuses,
    moneySources,
    monthlyTurnovers,
    incomes,
    cities,
    transFormedCityOrVillage,
    activitySubjects,
    economicActivityTypes,
    creditDebitCountries,
    isEntNeutral,
    isPrivateEnt,
    isPrivateInd,
    moneySourcesOptions,
    assets,
    propertySources,
    isCountryOfHighRiskChosen,
    hasKycScore,
    isKeepz = false,
  } = props?.data || {};

  return (
    <>
      {isPersonalDetails ? (
        <PersonDetails
          fullCountries={fullCountries}
          texClassifications={texClassifications}
          person={person}
          pepCategory={pepCategory}
          isPep={isPep}
          isCountryOfHighRiskChosen={isCountryOfHighRiskChosen}
          hasKycScore={hasKycScore}
          isEntNeutral={isEntNeutral}
          isPrivateEnt={isPrivateEnt}
          accountPurposes={accountPurposes}
          creditDebitCountries={creditDebitCountries}
          isKeepz={isKeepz}
        />
      ) : null}

      {isPepAndKyc ? (
        <PersonalAndFatca
          fullCountries={fullCountries}
          employMentStatuses={employMentStatuses}
          moneySources={moneySources}
          monthlyTurnovers={monthlyTurnovers}
          incomes={incomes}
          cities={cities}
          transFormedCityOrVillage={transFormedCityOrVillage}
          activitySubjects={activitySubjects}
          economicActivityTypes={economicActivityTypes}
          isEntNeutral={isEntNeutral}
          isPrivateEnt={isPrivateEnt}
          isPrivateInd={isPrivateInd}
          moneySourcesOptions={moneySourcesOptions}
          assets={assets}
          propertySources={propertySources}
          isPep={isPep}
          isCountryOfHighRiskChosen={isCountryOfHighRiskChosen}
          hasKycScore={hasKycScore}
        />
      ) : null}
    </>
  );
}
export default PiFormQuestions;
